import Buttons from "components/molecules/buttons";
import { Form } from "components/organisms";
import { trackInitialValues } from "components/organisms/forms/track/TrackForm";
import { useParamId } from "hooks/useParamId";
import { t } from "i18next";
import middleware from "middleware";
import { useLocation, useNavigate } from "react-router-dom";
import { PopupActions } from "reactjs-popup/dist/types";
import { useDeleteTrack, useGetTrack } from "services/tracks";
import { STATUS } from "services/types";
import { getMainTitle } from "utils/global/mainTitle.utils";
import { getLastPathname } from "utils/navbar/getParentPathname";
import { onErrorShowToast } from "utils/service/errorHandler";

const Track = () => {
  const trackId = useParamId("track");
  const { pathname } = useLocation();

  const navigate = useNavigate();

  const removeTrack = useDeleteTrack(trackId);
  const { data: track, isLoading } = useGetTrack(trackId);

  const onRemoveTrack = async (actions: PopupActions) => {
    await removeTrack?.mutateAsync(undefined, {
      onError: (error) => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => {
        navigate("/track");
      },
    });
  };

  return (
    <Form.Track
      i18nextPrefix="track"
      initialValues={
        track ? middleware.track.queryToForm(track) : trackInitialValues
      }
      onSubmit={() => {}}
      tittle={getMainTitle(track?.mainTitle)}
      status={{ isLoading: isLoading, displayMode: true }}
      topbarContent={
        <Buttons.IndividualPage
          onClick={() =>
            navigate(`/track/edit/${trackId}/${getLastPathname(pathname)}`, {
              replace: true,
            })
          }
          editDisabled={
            track?.trackStatus !== STATUS.draft &&
            track?.originalFileLink === null
          }
          editDisabledDescription={t("button.editBlocked-file")}
          name={track?.mainTitle.title}
          onRemove={onRemoveTrack}
        />
      }
    />
  );
};

export default Track;
